var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "Card",
    {
      staticClass: "w-full p-4 mb-4 customCardConatinerNotes hover:shadow-none",
    },
    [
      _c(
        "div",
        { staticClass: "w-full flex" },
        [
          _c(
            "div",
            { staticClass: "grow-1 w-full" },
            [
              _c(
                "div",
                [
                  _c("TableNotesAvatar", {
                    staticClass: "text-bold",
                    attrs: {
                      image: _vm.avatar,
                      initial: _vm.initials,
                      firstNames: _vm.firstNames,
                      lastNames: _vm.lastNames,
                      openDate: _vm.fullDate,
                      notes: _vm.notes,
                      avatarClasses: "customAvatarHeight",
                    },
                    scopedSlots: _vm._u(
                      [
                        {
                          key: "notesAction",
                          fn: function () {
                            return [_vm._t("actions")]
                          },
                          proxy: true,
                        },
                      ],
                      null,
                      true
                    ),
                  }),
                ],
                1
              ),
              _vm._t("default"),
            ],
            2
          ),
          _vm._t("secondary"),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }